module.exports = __webpack_public_path__ + "img/V-R-3-unload-connect-shadow.9d28b8cc.png";